import React, { useEffect, useMemo, useRef, useState } from "react";
import Pagination from 'react-bootstrap/Pagination';
import { useLocation } from "react-router-dom";
import DefaultHeader from 'components/PurchaserFrontend/Headers/DefaultHeader';
import ConfirmationAlertTwo from 'components/ConfirmationAlert/ConfirmationAlertTwo';
import NotificationAlert from "react-notification-alert";
import Datatable from "components/Core/DataTable";
import {
	Row,
	Col,
	ModalHeader,
	ModalBody,
	Form,
	Button,
	ModalFooter,
	Modal,
	FormGroup,
	Label,
	Input,
	Container,
} from "reactstrap";
import Notify from "../../lib/Utils/Alert";
import { MotionButton } from "../../components/Core/MotionStrap";
import PurchaseOrder from "../../lib/Core/Backend/Controllers/PurchaseOrder";
import ShoppingCartPurchaseOrder from "../../lib/Core/Backend/Controllers/ShoppingCartPurchaseOrder";
import PurchaseForm from "../../components/PurchaserFrontend/PurchaseOrder/PurchaseForm";
import Purchaser from '../../lib/Core/Backend/Controllers/Purchaser';
import GiftCardsFileForm from "components/PurchaseOrder/GiftCardsFileForm";
import FileUpload from "lib/Core/Backend/Controllers/FileUpload";
import Brand from "lib/Core/Backend/Controllers/Brand";
import CardType from "lib/Core/Backend/Controllers/CardType";
import { SwipeableDrawer } from "@mui/material";
import OrderDetails from "components/PurchaseOrder/OrderDetails";
import useCatalogs from "hooks/useCatalogs";
import ModalConfirm from "components/Purchaser/ModalConfirm";
import ModalDownloadFilePdfCsv from "components/Modal/DownloadFilePdfCsv";
import ShoppingCartController from "../../lib/Core/Backend/Controllers/ShoppingCartPurchaseOrder";
import html2pdf from 'html2pdf.js';
import Utils from 'lib/Utils/Utils';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Select from "react-select";
import Spinner from 'react-bootstrap/Spinner';
import { useHistory } from 'react-router-dom';
import OrderSummary from "./OrderSummary";
const ITEMS_PER_PAGE = 10;
const MAX_VISIBLE_PAGES = 5; 

const CustomPagination = ({ totalItems, currentPage, onPageChange }) => {
	const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
	const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
	const renderPageNumbers = () => {
		if (totalPages <= MAX_VISIBLE_PAGES) {
			return pageNumbers.map((page) => (
				<Pagination.Item
					key={page}
					active={page === currentPage}
					onClick={() => onPageChange(page)}
				>
					{page}
				</Pagination.Item>
			));
		}
		const startPage = Math.max(1, currentPage - Math.floor(MAX_VISIBLE_PAGES / 2));
		const endPage = Math.min(totalPages, startPage + MAX_VISIBLE_PAGES - 1);

		const pages = [];
		if (startPage > 1) {
			pages.push(
				<Pagination.Ellipsis key="ellipsis-start" disabled />
			);
		}
		for (let page = startPage; page <= endPage; page++) {
			pages.push(
				<Pagination.Item
					key={page}
					active={page === currentPage}
					onClick={() => onPageChange(page)}
				>
					{page}
				</Pagination.Item>
			);
		}

		if (endPage < totalPages) {
			pages.push(
				<Pagination.Ellipsis key="ellipsis-end" disabled />
			);
		}

		return pages;
	};
	return (
		<Pagination className="pagination-custom d-flex justify-content-end me-3">
			<Pagination.First onClick={() => onPageChange(1)} />
			<Pagination.Prev onClick={() => onPageChange(currentPage > 1 ? currentPage - 1 : 1)} />
			{renderPageNumbers()}
			<Pagination.Next onClick={() => onPageChange(currentPage < totalPages ? currentPage + 1 : totalPages)}/>
			<Pagination.Last onClick={() => onPageChange(totalPages)} />
		</Pagination>
	);
};
const Orders = ({ purchaserId, token }) => {
	const history = useHistory();
	const location = useLocation();
	const [showOrderDetailsModal, setShowOrderDetailsModal] = useState(false)
	const [searchQuery, setSearchQuery] = useState("");
	const [searchBrandQuary,setSearchBrandQuary] = useState('');
	const [searchRefQuery,setSearchRefQuery] = useState('')
	const { currencies } = useCatalogs();
	const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
	const shoppingCartPurchaseOrderCtl = useMemo(
		() => new ShoppingCartPurchaseOrder(token),
		[token]
	);
	const fileUploadCtl = useMemo(() => new FileUpload(token), [token]);
	const purchaserShoppingCart = useMemo(() => new ShoppingCartController(token), [token]);
	const brandsCtl = useMemo(() => new Brand(token), [token]);
	const cardTypeCtl = useMemo(() => new CardType(token), [token]);
	const [fileUrl, setFileUrl] = useState(null);
	const [giftCardsFile, setGiftCardsFile] = useState();
	const [giftCardsFileInfo, setGiftCardsFileInfo] = useState({});
	const [purchaseOrder, setPurchaseOrder] = useState({});
	const [purchaseDetails, setPurchaseDetails] = useState([]);
	const [purchaseOrderName, setPurchaseOrederName] = useState("");
	const [modal, setModal] = useState(false);
	const [modalGiftCardsFileForm, setModalGiftCardsFileForm] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);
	const [openDrawer, setOpenDrawer] = useState(false);
	const [reload, setReload] = useState(true);
	const [modalConfirm, setModalConfirm] = useState(false)
	const [filteredBrands, setFilteredBrands] = useState([]);
	const [orderreferenceValue, setOrderReferenceValue] = useState("");
	const [purchaserOrdersList, setPurchaserOrdersList] = useState([]);
	const [initialPurchaserOrdersList, setInitialPurchaserOrdersList] = useState([]);
	const [activeOp, setActiveOp] = useState("Add New");
	const [operativeRow, setOperativeRow] = useState({});
	const [orderDetail, setOrderDetail] = useState();
	const [brands, setBrands] = useState([]);
	const [cardTypes, setCardTypes] = useState([]);
	const [startDate, setStartDate] = useState('');
	const [endDate, setEndDate] = useState('');
	const [startDateTwo,setStartDateTwo] = useState('');
	const [endDateTwo,setEndDateTwo] = useState('')
	const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false)
	const [currentData, setCurrentData] = useState([])
	const [currentPage, setCurrentPage] = useState(1);
	const [currentList,setCurrentList] = useState([]);
    const [loader,setLoader] = useState(true)
	const [searchNames,setSearchNames] = useState("name");
	const [otherPagination,setOtherPagination] = useState(false)
    const [buttonLoading,setButtonLoding] = useState(false)
	const [total, setTotal] = useState(0);
	const [orderData, setOrderData] = useState([]);
	const [openDrawerId, setOpenDrawerId] = useState(null);
	const [confirmLoader,setConfirmLoader] = useState(false);
	const [csvLoader,setCsvLoader] = useState(false);	
	const [notificationShown, setNotificationShown] = useState(false);
	const [searchLoader,setSearchLoader] = useState(false);
	const [platForm,setPlatForm] = useState("Purchaser")
	const [confirmReport,setConfirmReport] = useState(false)
	const [showInitial,setShowInitial] = useState(false);
	const purchaserCtl = useMemo(() => new Purchaser(token), [token]);

	const handlePageChange = (pageNumber) => {
		setCurrentPage(pageNumber);
	};
	const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
	const endIndex = startIndex + ITEMS_PER_PAGE;
	const currentOrderData = currentData.slice(startIndex, endIndex);
	const handleReferenceValueChange = (newValue) => {
		setOrderReferenceValue(newValue);
	}
	const openModel = () => {
		setIsDownloadModalOpen(!isDownloadModalOpen)
		setFilteredBrands([]);
		setStartDate('')
		setEndDate('')
	}
	const modalConfirmToggle = () => setModalConfirm(!modalConfirm)
	const toggle = () => setModal(!modal);
	const toggleGiftCardsFileForm = () =>
		setModalGiftCardsFileForm(!modalGiftCardsFileForm);
	const toggleConfirm = () => setConfirmModal(!confirmModal);
	const toggleDrawer = () => setOpenDrawer(!openDrawer);
	const triggerReload = () => setReload(!reload);
	const toggleconfirmSalesReport = () => setConfirmReport(!confirmReport)
	const table = useRef();
	const alert = useRef();
	const debounceTimeout = useRef(null);
	const downloadLink = useRef();
	const startDateInput = useRef();
	const startInput = useRef();
	const endInput = useRef();
	const endDateInput = useRef();
	const toggleCreatePurchaseOrder = () => {
		setModal(false)
	}

	const { fromCart,showModal } = location.state || {};
	const orderNewData = location.state?.data || {};
	const confirmLoaderFile = () =>{
		setTimeout(() => {
			setConfirmLoader(false)	
		}, 1500);
		
	}



	const csvLoaderFile = () =>{
		setTimeout(() => {
			setCsvLoader(false);
		}, 1500);
	}
	
	const prepareToAdd = () => {
		toggle();
		setActiveOp("Add New");
		setPurchaseOrederName(`PCSR-PO-${+new Date()}`);
		setShowInitial(true)
	}
	const createPurchaseOrder = () => {
		setConfirmLoader(true)
		shoppingCartPurchaseOrderCtl.addPurcharseOrder(
			purchaseOrder, orderreferenceValue,
			(data) => {
				if (data.errorMessage) {
					Notify(alert, "danger", data.errorMessage);
					confirmLoaderFile()
				} else if(data?.error){
                   Notify(alert,"danger",data.error)
				   confirmLoaderFile()
				}else{
					triggerReload();
					Notify(alert,"success","Order has been created")
					confirmLoaderFile()
					purchaserShoppingCart.getCart(response => {
						if (response && !response.error) {
							localStorage.setItem("AddItem",JSON.stringify(response?.items?.length))
						} else {
							Notify(alert, "danger", response.errorMessage || response.errorCode || 'Error adding item');
						}
					})
				}
			}
		)
	}
	const onModalConfirmBack = () => {
		modalConfirmToggle();
		setModal(true);
	}
	const onModalConfirmDone = () => {
		modalConfirmToggle();
		createPurchaseOrder();
	}
	const modalOrderToConfirm = () => {
		if (purchaseDetails.length) {
			modalConfirmToggle();
			toggleCreatePurchaseOrder()
		} else {
			Notify(alert, 'danger', "Please make a order");
		}
	}
	const handleClick = (data) => {
		setOrderDetail(data);
		setShowOrderDetailsModal(!showOrderDetailsModal);
	};
	function confirmDelete() {
		const row = operativeRow;
		setOperativeRow(null);
		row.remove().draw();
		toggleConfirm();
	}
	function handleModalAlerts(data) {
		Notify(alert, "danger", data);
	}

	function uploadGiftCardsFile(e) {
		e.preventDefault();
		if (!!giftCardsFile) {
			fileUploadCtl.add(giftCardsFile, giftCardsFileInfo);
			toggleGiftCardsFileForm();
		}
	}
	const prepareDetails = (row) => {
		setOrderDetail(row.data());
		toggleDrawer();
	};

	const customStyles = {
		container: (provided) => ({
			...provided,
			marginTop: '31px',
		}),
		menu: (provided) => ({
			...provided,
			zIndex: 1000,
		}),
		indicatorSeparator: (provided, state) => ({
			...provided,
			display: "none",
		}),
	};
	const downloadFulfillment = (e) => {
		purchaseOrderCtl.fulfillmentFile(orderDetail.name, data => {
			if (data.error) {
				Notify(alert, 'danger', 'Something went wrong')
			} else {
				setFileUrl(data.downloadLink)
			}
		})
	}
	useEffect(() => {
		if (fileUrl)
			downloadLink.current.click()
		setFileUrl(null)
	}, [fileUrl]);

	useEffect(() => {
		brandsCtl.all((data) => {
			if (data.error || data.errorMessage) {
				Notify(alert, "danger", data.errorMessage ?? data.error);
			} else {
				setBrands(data);
			}
		});
		cardTypeCtl.all((data) => {
			if (data.error || data.errorMessage) {
				Notify(alert, "danger", data.errorMessage ?? data.error);
			} else {
				setCardTypes(data);
			}
		});
	}, [brandsCtl, cardTypeCtl]);

	useEffect(()=>{
		if(fromCart && showModal){
			toggle()
			setActiveOp("Add New");
			setPurchaseOrederName(`PCSR-PO-${+new Date()}`);
			history.replace({
				pathname: location.pathname,
				state: {
					...location.state,
					fromCart: false,
					showModal: false,
				},
			});
		}
		
	},[fromCart ,showModal])

	useEffect(() => {
		if (!!purchaserId) {
			purchaseOrderCtl.allBySource(purchaserId, (data) => {
				if(data.length === 0 ){
					setLoader(false)
				}
				if (data && !data.error) {
					setLoader(false)
					let purchaseOrders = data.map((order) => {
						let orderCurrency = currencies.find(currency => currency.id === order.currencyId)
						const currencyFormat = new Intl.NumberFormat('en-US', {
							style: 'currency',
							currency: orderCurrency?.code ?? 'USD'
						})
						
						order.totalAmount = currencyFormat.format(order.totalAmount);
						order.subtotal = currencyFormat.format(order.subtotal)
						return { ...order, currency: orderCurrency?.code ?? 'USD' };
					});
					setPurchaserOrdersList(purchaseOrders)
					setInitialPurchaserOrdersList(purchaseOrders)
					let array = purchaseOrders.sort((a, b) => {
						const dateA = new Date(a.createdAt);
						const dateB = new Date(b.createdAt);
					
						// Compare full date and time
						return dateB - dateA;
					});
					  setCurrentList(array)
					setCurrentData(array)
				} else {
					Notify(alert, "danger", data.errorMessage ?? data.error);
				}
			});
		}
	}, [reload, purchaserId]);

	
	const fetchPurchaserData = ()=> {
		purchaserCtl.purchaserCheck(purchaserId, (data) => {
	
			if (data && !data.error) {
				if(data?.users[0]?.enabled == false){
					sessionStorage.removeItem("accessToken")
					  window.location.href="purchaser-auth/login"
			  }
			}else{
			 if((data?.errorMessage=="Purchaser not found"&& data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
	
				Notify(alert, 'danger', data?.errorMessage ?? data?.error);
					sessionStorage.removeItem("accessToken")
					window.location.href="purchaser-auth/login"
				}
				if((data?.errorMessage.includes("Username was not found") && data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
		  
				  Notify(alert, 'danger', data?.errorMessage ?? data?.error);
					  sessionStorage.removeItem("accessToken")
					  window.location.href="purchaser-auth/login"
				  }
			}
	})
	}
	useEffect(()=>{    
	fetchPurchaserData()
	
	},[purchaserId])
	


	const handleDate = (e) => {
		if (e.target.id === "startDate") {
		  const selectedStartDate = new Date(e.target.value);
		  
		  
		 
	  
		  setStartDate(e.target.value);
		  setEndDate(null);
		  endDateInput.current.value = "";
		  endDateInput.current.select();
		} else {
		  if (!startDate) {
			Notify(alert, "danger", "First select a start date");
			endDateInput.current.value = "";
			startDateInput.current.focus();
			return;
		  }
		  
	  
		  const selectedEndDate = new Date(e.target.value);
		  const maxAllowedEndDate = new Date(startDate);
		  maxAllowedEndDate.setDate(maxAllowedEndDate.getDate() + 93); // 3 months = 93 days
	  
		  
		  if (selectedEndDate > maxAllowedEndDate) {
			Notify(alert, "danger", "End date cannot be more than 3 months  from the start date.");
			endDateInput.current.value = "";
			return;
		  }
	  
		  setEndDate(e.target.value);
		}
	  };
	  

	const handleDateTwo = (e) => {
		if (e.target.id === 'startDate') {
			setStartDateTwo(e.target.value)
			setEndDateTwo(null)
			endInput.current.value = '';
			endInput.current.select();
		} else {
			if (!startDateTwo) {
				Notify(alert, 'danger', 'First Select a start date');
				endInput.current.value = '';
				startInput.current.focus();
				return;
			}
			setEndDateTwo(e.target.value)
		}
	}
	
	

	
	const downloadPdf = () => {
		if(!startDate && !endDate){
			Notify(alert,"danger","First Select a start date and End date")
			return;
		}
		
		
		if (filteredBrands?.length == 0) {
			Notify(alert, 'danger', 'No Filterdata within these date range');
		}
		else {
			const doc = new jsPDF();
			const headers = [['Brand', 'Date', 'Name', 'Order', 'Face Val', 'Qty', 'Disc', 'Disc Val', 'Total', 'Status']];
			const rows = filteredBrands?.map(obj => [obj.brand, obj.date, obj.customerName, obj.orderName, " $ " + parseFloat(obj.faceValue).toFixed(2), parseFloat(obj.quantity).toFixed(2), parseFloat(obj.discount).toFixed(2) + " % ", " $ " + obj.discountValue, " $ " + obj.totalValue,
			getStatusText(obj.status) ]);
			doc.autoTable({
				head: headers,
				body: rows,
				styles: { fontSize: 8 },
				});
			doc.save('orders.pdf');
		}
	};

	const getStatusText = (status) => {
		switch (status) {
			case 'On Hold':
			case 'API Issue':
			case 'Error':
			case 'Processing':
			case 'In-progress':
			case 'Incomplete':
			case 'CSV MISMATCHED':
			case 'Pending':	
				return 'Processing';
			case 'API Low Fund':
			case 'Non API Low Fund':
			case 'Invoice Order':
			case 'Non API Invoice Order':
				return 'Awaiting Payments';
			default:
				return status;
		}
	};

	const arrayToCSV = (arr) => {
		const columnNames = Object.keys(arr[0]);
		const columnHeaders = columnNames.join(',');
		const rows = arr.map((item) => {
			const values = Object.values(item).map(value => {
				return getStatusText(value);
			});
			return values.join(',');
		}).join('\n');
		return `${columnHeaders}\n${rows}`;
	};
	
	const downloadCsvFile = () => {
       setCsvLoader(true)
		if(!startDate && !endDate){
			Notify(alert,"danger","First Select a start date and End date")
			csvLoaderFile();
			return;
		}
		
			setButtonLoding(true)
			purchaseOrderCtl.downloadPurchaserOrder(purchaserId, startDate, endDate, (data) => {
				if (data && !data.error) {
					setFilteredBrands(data)
					setButtonLoding(false)
					toggleconfirmSalesReport()
					openModel()
					setStartDate('')
					setEndDate('')
				} else {
					Notify(alert, "danger", data.errorMessage ?? data.error);
					setTimeout(() => {
						setButtonLoding(false)
					}, 3000);
				}
			});
		
			
		
	};
	// const handleSearchInputChange = (event) => {
	// 	setSearchQuery(event.target.value);
	// 	if (!event.target.value) {
	// 		let array = purchaserOrdersList.sort((a, b) => {
	// 			const dateA = new Date(a.createdAt);
	// 			const dateB = new Date(b.createdAt); 
	// 			const yearComparison = dateB.getFullYear() - dateA.getFullYear();
	// 			if (yearComparison !== 0) return yearComparison;
	// 			const monthComparison = dateB.getMonth() - dateA.getMonth();
	// 			if (monthComparison !== 0) return monthComparison;
	// 			const dayComparison = dateB.getDate() - dateA.getDate();
	// 			if (dayComparison !== 0) return dayComparison;
	// 			const timeA = dateA.toLocaleTimeString();
	// 			const timeB = dateB.toLocaleTimeString();
	// 			return timeB.localeCompare(timeA);
	// 		  });
	// 		setCurrentData(array)
	// 	}
	// 	else {
	// 		if (event.target.value) {
	// 			const searchResults = purchaserOrdersList?.filter((item) => {
	// 				const values = Object.values(item);
	// 				return values.some(
	// 					(value) =>
	// 						typeof value === "string" &&
	// 						value.toLowerCase().includes(event.target.value.toLowerCase())
	// 				);
	// 			});
	// 			let array = searchResults.sort((a, b) => {
	// 				const dateA = new Date(a.createdAt);
	// 				const dateB = new Date(b.createdAt);				  
	// 				const yearComparison = dateB.getFullYear() - dateA.getFullYear();
	// 				if (yearComparison !== 0) return yearComparison;
	// 				const monthComparison = dateB.getMonth() - dateA.getMonth();
	// 				if (monthComparison !== 0) return monthComparison;
	// 				const dayComparison = dateB.getDate() - dateA.getDate();
	// 				if (dayComparison !== 0) return dayComparison;				  
	// 				const timeA = dateA.toLocaleTimeString();
	// 				const timeB = dateB.toLocaleTimeString();
	// 				return timeB.localeCompare(timeA);
	// 			  });
	// 			setCurrentData(array);
	// 			setCurrentPage(1);
	// 			return searchResults.length > 0 ? searchResults : "No match found";
	// 		}
	// 	}
	// };

	const handleSearchInputChange = (event) => {
		const query = event.target.value;
		setSearchQuery(query);
	
		if (!query) {
			let array = purchaserOrdersList.sort((a, b) => {
				const dateA = new Date(a.createdAt);
				const dateB = new Date(b.createdAt);
				const yearComparison = dateB.getFullYear() - dateA.getFullYear();
				if (yearComparison !== 0) return yearComparison;
				const monthComparison = dateB.getMonth() - dateA.getMonth();
				if (monthComparison !== 0) return monthComparison;
				const dayComparison = dateB.getDate() - dateA.getDate();
				if (dayComparison !== 0) return dayComparison;
				const timeA = dateA.toLocaleTimeString();
				const timeB = dateB.toLocaleTimeString();
				return timeB.localeCompare(timeA);
			});
			setCurrentData(array);
			setInitialPurchaserOrdersList(purchaserOrdersList)
		} else {
			const searchResults = purchaserOrdersList?.filter((item) => {
				if (searchNames === "name") {
					return item.name?.toLowerCase().includes(query.toLowerCase());
				}  else {
					const values = Object.values(item);
					return values.some(
						(value) =>
							typeof value === "string" &&
							value.toLowerCase().includes(query.toLowerCase())
					);
				}
			});
	
			if (searchResults.length === 0  && !notificationShown) {
				Notify(alert, "danger", "Option is not valid corresponding for search  Or  No match found" );
				setNotificationShown(true); 
			} else if (searchResults.length > 0) {
				setNotificationShown(false); 
			}
			setOtherPagination(true)
			setInitialPurchaserOrdersList(searchResults)
			let array = searchResults.sort((a, b) => {
				const dateA = new Date(a.createdAt);
				const dateB = new Date(b.createdAt);
				const yearComparison = dateB.getFullYear() - dateA.getFullYear();
				if (yearComparison !== 0) return yearComparison;
				const monthComparison = dateB.getMonth() - dateA.getMonth();
				if (monthComparison !== 0) return monthComparison;
				const dayComparison = dateB.getDate() - dateA.getDate();
				if (dayComparison !== 0) return dayComparison;
				const timeA = dateA.toLocaleTimeString();
				const timeB = dateB.toLocaleTimeString();
				return timeB.localeCompare(timeA);
			});
	
			setCurrentData(array);
			setCurrentPage(1);
			return searchResults.length > 0 ? searchResults : "No match found";
		}
	};

	const handleSearchRefInputChange = (event) => {
		const query = event.target.value;
		setSearchRefQuery(query);
	
		if (!query) {
			let array = purchaserOrdersList.sort((a, b) => {
				const dateA = new Date(a.createdAt);
				const dateB = new Date(b.createdAt);
				const yearComparison = dateB.getFullYear() - dateA.getFullYear();
				if (yearComparison !== 0) return yearComparison;
				const monthComparison = dateB.getMonth() - dateA.getMonth();
				if (monthComparison !== 0) return monthComparison;
				const dayComparison = dateB.getDate() - dateA.getDate();
				if (dayComparison !== 0) return dayComparison;
				const timeA = dateA.toLocaleTimeString();
				const timeB = dateB.toLocaleTimeString();
				return timeB.localeCompare(timeA);
			});
			setCurrentData(array);
			setInitialPurchaserOrdersList(purchaserOrdersList)
		} else {
			const searchResults = purchaserOrdersList?.filter((item) => {
				if (searchNames === "orderReference") {
					return item.orderReference?.toLowerCase().includes(query.toLowerCase());
				}  else {
					const values = Object.values(item);
					return values.some(
						(value) =>
							typeof value === "string" &&
							value.toLowerCase().includes(query.toLowerCase())
					);
				}
			});
	
			if (searchResults.length === 0  && !notificationShown) {
				Notify(alert, "danger", "Option is not valid corresponding for search  Or  No match found" );
				setNotificationShown(true); 
			} else if (searchResults.length > 0) {
				setNotificationShown(false); 
			}
			setOtherPagination(true)
			setInitialPurchaserOrdersList(searchResults)
			let array = searchResults.sort((a, b) => {
				const dateA = new Date(a.createdAt);
				const dateB = new Date(b.createdAt);
				const yearComparison = dateB.getFullYear() - dateA.getFullYear();
				if (yearComparison !== 0) return yearComparison;
				const monthComparison = dateB.getMonth() - dateA.getMonth();
				if (monthComparison !== 0) return monthComparison;
				const dayComparison = dateB.getDate() - dateA.getDate();
				if (dayComparison !== 0) return dayComparison;
				const timeA = dateA.toLocaleTimeString();
				const timeB = dateB.toLocaleTimeString();
				return timeB.localeCompare(timeA);
			});
	
			setCurrentData(array);
			setCurrentPage(1);
			return searchResults.length > 0 ? searchResults : "No match found";
		}
	};

	const handleSearchInputBrand = (event) => {
		const query = event.target.value;
		setSearchBrandQuary(query);
	
		if (debounceTimeout.current) {
		  clearTimeout(debounceTimeout.current);
		}
	
		debounceTimeout.current = setTimeout(() => {
		  if (!query) {
			let array = purchaserOrdersList.sort((a, b) => {
			  const dateA = new Date(a.createdAt);
			  const dateB = new Date(b.createdAt);
			  const yearComparison = dateB.getFullYear() - dateA.getFullYear();
			  if (yearComparison !== 0) return yearComparison;
			  const monthComparison = dateB.getMonth() - dateA.getMonth();
			  if (monthComparison !== 0) return monthComparison;
			  const dayComparison = dateB.getDate() - dateA.getDate();
			  if (dayComparison !== 0) return dayComparison;
			  const timeA = dateA.toLocaleTimeString();
			  const timeB = dateB.toLocaleTimeString();
			  return timeB.localeCompare(timeA);
			});
			setCurrentData(array);
			setInitialPurchaserOrdersList(purchaserOrdersList)
		  } else {
			purchaserCtl.brandSearch(purchaserId, query, (data) => {
			  if (data && !data.error) {
				setOtherPagination(true)
				setInitialPurchaserOrdersList(data)
				let array = data.sort((a, b) => {
				  const dateA = new Date(a.createdAt);
				  const dateB = new Date(b.createdAt);
				  const yearComparison = dateB.getFullYear() - dateA.getFullYear();
				  if (yearComparison !== 0) return yearComparison;
				  const monthComparison = dateB.getMonth() - dateA.getMonth();
				  if (monthComparison !== 0) return monthComparison;
				  const dayComparison = dateB.getDate() - dateA.getDate();
				  if (dayComparison !== 0) return dayComparison;
				  const timeA = dateA.toLocaleTimeString();
				  const timeB = dateB.toLocaleTimeString();
				  return timeB.localeCompare(timeA);
				});
				setCurrentData(array);
				setCurrentPage(1);
				return data?.length > 0 ? data : "No Data Found";
			  } else {
				// Notify(alert, "danger", data?.errorMessage ?? data?.error);
				setOtherPagination(true)
				setCurrentData([]);
				setInitialPurchaserOrdersList([])
				
			  }
			});
		  }
		}, 300); // 300ms debounce delay
	  };
	

	const searchByOption = [
		{value:"name",label:"Order Number"},
		{value:"orderReference",label:"RefId"},
		{value:"Brand",label:"Brand Name"}
	]




const handleSearchFilter = (selectedOption) =>{
	if(selectedOption){
		const value = selectedOption?.value
		setSearchNames(value)
	  }
}

const searchLoaderFile = () =>{
	setTimeout(() => {
		setSearchLoader(false)
	}, 1500);
}

const handleSearchDate = () =>{
 if(startDateTwo && endDateTwo){
	setSearchLoader(true)
	purchaseOrderCtl.filterDateOrders(purchaserId,startDateTwo,endDateTwo,(data)=>{
		if(data && !data.error){
			searchLoaderFile();
			setOtherPagination(true)
			setInitialPurchaserOrdersList(data)
			let array = data.sort((a, b) => {
				const dateA = new Date(a.createdAt);
				const dateB = new Date(b.createdAt);
				const yearComparison = dateB.getFullYear() - dateA.getFullYear();
				if (yearComparison !== 0) return yearComparison;
				const monthComparison = dateB.getMonth() - dateA.getMonth();
				if (monthComparison !== 0) return monthComparison;
				const dayComparison = dateB.getDate() - dateA.getDate();
				if (dayComparison !== 0) return dayComparison;
				const timeA = dateA.toLocaleTimeString();
				const timeB = dateB.toLocaleTimeString();
				return timeB.localeCompare(timeA);
			});
			setCurrentData(array)
			
			// setStartDateTwo('');
			// setEndDateTwo('');
			
		}else{
			setCurrentData([])
			Notify(alert,"danger",data?.errorMessage ?? data?.error)
			searchLoaderFile();
		}
	})
 }
}
const totalItems = 
    (otherPagination === true && searchNames === "orderReference") || 
    (otherPagination === true && searchNames === "name") || 
    (otherPagination === true && searchNames === "Brand") 
        ? initialPurchaserOrdersList?.length 
        : purchaserOrdersList?.length;

const openDrawerRow = (data) =>{
	setLoader(true)
	setOrderData([])
	setOpenDrawerId((prevId) => (prevId === data?.id ? null : data?.id));
	purchaseOrderCtl.purchaseOrderDetail(data?.id, data => {
		if (data.error || data.errorMessage) {
			Notify(alert, 'danger', data.errorMessage ?? data.error)
		} else {
			setOrderData(data)
			setLoader(false)
			let totalPrice = data.reduce((previousValue, currentValue) => {
				return previousValue + currentValue.total;
			  }, 0);
			  setTotal(totalPrice)
			
		}
	})
}

const handleShowingButton = () =>{
	setShowInitial(true)
}

	return (
		<div className='dashboardPage'>
			<ConfirmationAlertTwo
			/>
			<NotificationAlert ref={alert} />
			<ModalDownloadFilePdfCsv endDateInput={endDateInput} startDateInput={startDateInput} handleDate={handleDate} startDate={startDate}
				isOpen={isDownloadModalOpen} toggle={openModel} downloadPdf={downloadPdf} downloadCsvFile={downloadCsvFile} purchaserOrder={"purchaserOrder"} buttonLoading={buttonLoading} />
			<Container className="mt-4" fluid>
				{showOrderDetailsModal ? <OrderSummary handleClick={handleClick} orders={orderDetail} token={token} />
					:
					<>
						<h5 className='mb-3'>Purchase Orders</h5>
						<div className="row col-lg-12 mb-3" style={{marginLeft:"-29px"}}>
						<div className="col-auto col-lg-auto" >
									<button className='btn btn-primaryTwo' onClick={prepareToAdd}><i className='bx bxs-cart me-1'  ></i>  <span className='d-none d-xl-inline'>Create New Order</span></button>
						   </div>
							<div className="col-auto col-lg-auto">
									<button className='btn btn-primaryTwo' onClick={openModel}><i className='bx bxs-download me-1 py-0' ></i> <span className='d-none d-xl-inline'>Download Historical</span></button>
								</div>
								

							</div>
						<div className="sortTools">
							<div className="row g-1 g-sm-3">
								<div className="col-12 col-lg-3 col-md-6 col-xl-3">
									<Select 
									placeholder="Search by"
									isClearable={true}
									options={searchByOption}
									defaultValue={searchByOption[0]}
									onChange={handleSearchFilter}
									styles={customStyles}
									
									/>
								</div>
								<div className="col-12  col-lg-3 col-md-6 col-xl-3 mt-3">
									<div className="searchSort position-relative" style={{marginTop:"31px"}}>
									{
										searchNames === 'Brand' ? (
											<input
											type="text"
											value={searchBrandQuary}
											onChange={handleSearchInputBrand}
											placeholder="Search by Brands Name"
											className="form-control pe-4 h-100"
											/>
										) : searchNames === 'name' ? (
											<input
											type="text"
											value={searchQuery}
											onChange={handleSearchInputChange}
											placeholder="Search by Order Number"
											className="form-control pe-4 h-100"
											/>
										) : searchNames === 'orderReference' ? (
											<input
											type="text"
											value={searchRefQuery}
											onChange={handleSearchRefInputChange}
											placeholder="Search by Ref ID"
											className="form-control pe-4 h-100"
											/>
										) : null
										}

										
										<button className='d-flex align-items-center btn  position-absolute p-0 h-100 px-3' style={{right:"0",top:"50%",transform:"translate(0%,-50%)",background: "#2665F2"}}><i className='bx bx-search ' style={{color:"white"}}></i></button>
									</div>
								</div>
								<div className="col-12 col-lg-2 col-md-6 col-xl-2">
								<FormGroup>
									<Label for='startDate' >Start date</Label>
									<Input type='date' id='startDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={startInput} onChange={handleDateTwo}/>
								</FormGroup>
								</div>
								<div className="col-12 col-lg-2 col-md-6 col-xl-2">
								<FormGroup>
								<Label for='endDate'>End date</Label>
									<Input type='date' id='endDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={endInput} onChange={handleDateTwo} min={startDate ? startDate : ''}/>
								</FormGroup>
								</div>
								<div className="col-12 col-lg-2 col-md-6 col-xl-2 mt-lg-5">
								<button className='btn btn-primaryTwo' onClick={handleSearchDate} style={{ height: '39px', display: 'flex', alignItems: 'center' }} disabled={searchLoader}>{!searchLoader && <i className='bx bx-search me-1 py-0'></i>}
								<span className='d-none d-xl-inline'>{!searchLoader && "Search"}{
									searchLoader &&
									<Spinner
									as="span"
									animation="border"
									size="sm"
									role="status"
									aria-hidden="true"
									style={{marginLeft:"5px"}}
									/>

									}</span></button>

								</div>
							</div>
						</div>
						<div className="card table-widget" style={{ marginTop: "16px", marginBottom: "0" }}>
							<div className="card-body">
								<div className="table-responsive p-2" style={{ maxHeight: '600px', overflowY: 'hidden' }}>
									{/* <div style={{ overflowY: 'auto', maxHeight: '500px' }}>
									<table className="table table-borderless table-hover order_table" style={{ tableLayout: 'fixed', minWidth: '900px'}}>
										<thead  className="mb-4" style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
											<tr  className="mb-4">
												<th style={{ width: "auto" }} >Date
												</th>
												<th style={{ width: "auto" }}>Order Number
												</th>
												<th style={{ width: "auto" }}>RefId</th>
												<th style={{ width: "auto" }} className="text-center">Currency
												</th>
												<th style={{ width: "auto" }} className="text-center">Total Gift Card
												</th>
												<th style={{ width: "auto" }} className="text-center">Total Amount
												</th>
												<th style={{ width: "auto" }} className="text-center">Quantity
												</th>
												<th style={{ width: "156px" }}>Status
												</th>
												<th style={{ width: "auto" }}></th>
											</tr>
										</thead>
										<tbody>
												{currentOrderData?.length > 0 ? currentOrderData?.sort((a, b) => {
													 const dateA = new Date(a.createdAt);
													 const dateB = new Date(b.createdAt);
												 
													 // Compare full date and time
													 return dateB - dateA;

													// const dateA = parseDate(a.createdAt);
													// const dateB = parseDate(b.createdAt);
													
													// return dateB - dateA;
												}).map((data, index) => {
													return (
														<tr key={index} onClick={()=>openDrawerRow(data)} style={{cursor:"pointer"}}>
															<td>{data?.createdAt}</td>
															<td><p className="mb-0" style={{fontSize:"14px"}}>{data?.name}</p></td>
															<td><p className="mb-0" style={{fontSize:"14px"}}>{data?.orderReference}</p></td>
															<td className="text-center">{data?.currency}</td>
															<td className="text-center">{data?.subtotal}</td>
															<td className="text-center">{data?.totalAmount}</td>
															<td className="text-center">{data?.totalQuantity}</td>
															<td>{data?.status == 1 ? <span className="badge badge-pill text-white bg-info">Open</span>
																: data?.status == 2 ?
																	<span className="badge badge-pill text-white bg-radicalYellow">Processing</span> : data?.status == 3 ?
																		<span className="badge badge-pill text-white bg-radicalRed">Cancelled</span> : data?.status == 4 ?
																			<span className="badge badge-pill text-white bg-shamrock">Completed</span> : data?.status == 5 ?
																				<span className="badge badge-pill text-white bg-radicalYellow">Processing</span> : (data?.status == 6 || data?.status == 7 || data?.status == 9 || data?.status == 10) ?
																					<span className="badge badge-pill text-white bg-radicalAssColor">Awaiting payment</span> : (data?.status == 8 || data?.status == 11 || data?.status == 12 || data?.status == 13 || data?.status == 14) ?
																						<span className="badge badge-pill text-white bg-radicalYellow">Processing</span> : (data?.status == 15) ?
																						<span className="badge badge-pill text-white bg-radicalRed">Temporary out of stock</span> : null
																						
																						
															}</td>
														<td><button className='btn btn-primaryTwo py-1' onClick={() => handleClick(data)}>View</button></td>
													</tr>
													
												)
											}) :
											 loader  ?
											 <tr>
											  <td colSpan={8}>
												<div className="spinner-border text-muted text-center"></div>
											  </td>
											</tr>
											:
											<tr>
						                      <td colSpan={8}>{"No orders found !"}</td>
												</tr>
											}
										</tbody>
									</table>
									</div> */}
									<div style={{ overflowY: 'auto', maxHeight: '500px' }}>
									<table className="table table-borderless table-hover order_table" style={{ tableLayout: 'fixed', minWidth: '900px'}}>
										<thead className="mb-4" style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
										<tr className="mb-4">
											<th style={{ width: "auto" }}>Date</th>
											<th style={{ width: "auto" }}>Order Number</th>
											<th style={{ width: "auto" }}>RefId</th>
											<th style={{ width: "auto" }} className="text-center">Currency</th>
											<th style={{ width: "auto" }} className="text-center">Total Gift Card</th>
											<th style={{ width: "auto" }} className="text-center">Total Amount</th>
											<th style={{ width: "auto" }} className="text-center">Quantity</th>
											<th style={{ width: "156px" }}>Status</th>
											<th style={{ width: "auto" }}></th>
										</tr>
										</thead>
										<tbody>
										{currentOrderData?.length > 0 ? currentOrderData
											.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
											.map((data, index) => (
											<React.Fragment key={index}>
												<tr onClick={() => openDrawerRow(data)} style={{ cursor: "pointer" }}>
												<td>{data?.createdAt}</td>
												<td><p className="mb-0" style={{ fontSize: "14px" }}>{data?.name}</p></td>
												<td><p className="mb-0" style={{ fontSize: "14px" }}>{data?.orderReference}</p></td>
												<td className="text-center">{data?.currency}</td>
												<td className="text-center">{data?.subtotal}</td>
												<td className="text-center">{data?.totalAmount}</td>
												<td className="text-center">{data?.totalQuantity}</td>
												<td>
													{data?.status == 1 ? <span className="badge badge-pill text-white bg-info">Open</span> :
													data?.status == 2 || data?.status == 5 || data?.status == 8 || data?.status == 11 ||  data?.status == 16 ? <span className="badge badge-pill text-white bg-radicalYellow">Processing</span> :
													data?.status == 3 ? <span className="badge badge-pill text-white bg-radicalRed">Cancelled</span> :
													data?.status == 4 ? <span className="badge badge-pill text-white bg-shamrock">Completed</span> :
													(data?.status == 6 || data?.status == 7 || data?.status == 9 || data?.status == 10) ? 
													<span className="badge badge-pill text-white bg-radicalAssColor">Awaiting payment</span> :
													(data?.status == 15) ? <span className="badge badge-pill text-white bg-radicalRed">Temporary out of stock</span> :
													(data?.status == 14) ? <span className="badge badge-pill text-white bg-radicalRed">Error</span> :
													null}
												</td>
												<td>
													<button className='btn btn-primaryTwo py-1' onClick={() => handleClick(data)}>View</button>
												</td>
												</tr>

												{/* Nested table conditionally rendered */}
												{openDrawerId === data?.id && (
												<tr>
													<td colSpan="9">
													<table className="table nested_table">
														<thead>
														<tr>
															<th className="border-0">Brand</th>
															<th className="border-0">Card Type</th>
															<th className="border-0">Currency</th>
															<th className="border-0">Fee</th>
															<th className="border-0">Discount</th>
															<th className="border-0">Qty</th>
															<th className="border-0">Value</th>
															<th className="border-0">Subtotal</th>
															<th className="border-0">Total</th>
														</tr>
														</thead>
														<tbody>
														{orderData?.length > 0 ? orderData.map((nestedData, nestedIndex) => (
															<tr key={nestedIndex}>
															<td>{nestedData?.brandName}</td>
															<td>{nestedData?.cardTypeName}</td>
															<td>{nestedData?.currency}</td>
															<td>${nestedData?.fee.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
															<td>{nestedData?.discount.toFixed(2)}%</td>
															<td>{nestedData?.quantity}</td>
															<td>${nestedData?.amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
															<td>${nestedData?.subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
															<td>${nestedData?.total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
															</tr>
														)) : loader ? (
															<tr>
															<td colSpan="9" style={{ textAlign: "center" }}>
																<div className="spinner-border text-muted text-center"></div>
															</td>
															</tr>
														) : (
															<tr>
															<td colSpan="9" className="text-center">No order details found</td>
															</tr>
														)}
														</tbody>
													</table>
													</td>
												</tr>
												)}
											</React.Fragment>
											)) : loader ? (
											<tr>
												<td colSpan="8">
												<div className="spinner-border text-muted text-center"></div>
												</td>
											</tr>
											) : (
											<tr>
												<td colSpan="8">No orders found!</td>
											</tr>
											)}
										</tbody>
									</table>
									</div>

								</div>								
							</div>
							<div className="pagination_area">
									<CustomPagination
										totalItems={totalItems}
										currentPage={currentPage}
										onPageChange={handlePageChange}
									/>
							</div>
						</div>
						<ModalConfirm token={token} isOpen={modalConfirm} toggle={modalConfirmToggle} onBack={onModalConfirmBack} onConfirm={onModalConfirmDone} data={purchaseDetails} showColor={true} confirmLoader={confirmLoader} />
						<Modal
							isOpen={modal}
							toggle={toggle}
							backdrop="static"
							centered={true}
							size="xl"
						>
							<ModalHeader toggle={toggle} className="custom_header_colourTwo d-flex align-items-center justify-content-between">
								{activeOp} Order
							</ModalHeader>
							<Form>
								<ModalBody>
									
									<PurchaseForm
										name={purchaseOrderName}
										setPurchaseOrder={setPurchaseOrder}
										setPurchaseOrderDetails={setPurchaseDetails}
										loggedInPurchaser={purchaserId}
										token={token}
										currencies={currencies}
										onReferenceValueChange={handleReferenceValueChange}
										orderNewData={orderNewData}
										showInitial={showInitial}
										handleReset={handleShowingButton}
										
									/>
								</ModalBody>
								<ModalFooter>
									<Button type="button" color="secondary" onClick={toggle}>
										Cancel
									</Button>{" "}
									<Button type="button" className="btn btn-primaryTwo" onClick={modalOrderToConfirm}>
										Next
									</Button>
								</ModalFooter>
							</Form>
						</Modal>
						<Modal isOpen={confirmReport} toggle={toggleconfirmSalesReport} centered>
						<ModalHeader toggle={toggleconfirmSalesReport} className="custom_header_colourTwo d-flex align-items-center justify-content-between bg-success">Confirmation</ModalHeader>
						<ModalBody>
						  The sales report will be sent to your email in a few minutes.
						</ModalBody>
						<ModalFooter>
							<Button  type="button"  color="secondary" onClick={toggleconfirmSalesReport}>Cancel</Button>
						</ModalFooter>
						</Modal>
					</>
				}
			</Container>
		</div>
	)
}

export default Orders